import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        const isMinDisabled = this.props.min == this.props.current ? true : false;
        const isMaxDisabled = this.props.max == this.props.current ? true : false;
        return (
            <div className="pagination">
                <button className='left' onClick={() => {this.props.dir('left')}} disabled={isMinDisabled}>
                    <span className="left"></span> 
                </button>
                <div className='value active'>{this.props.current}</div>
                <div className='value'>з</div>
                <div className='value'>{this.props.max}</div>
                <button className='right' onClick={() => {this.props.dir('right')}} disabled={isMaxDisabled}>
                <span className="right"></span> 
                </button>
            </div>
        )
    }
}

export default Pagination;

Pagination.propTypes = {
    current: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    dir: PropTypes.func.isRequired
}